export { default as usePaymentErrorStaticModel } from './use-payment-error-static-model'
